import { Loader } from '@/components/ui'
import {
  useChatSessions,
  useCurrentSessionId,
  useLoadingSessions,
} from '../hooks'
import ChatThread from './ChatThread'
import EmptyChatState from './EmptyChatState'

interface ThreadViewProps {
  slug: string
  onCreateNew: () => Promise<void> | void
  creating: boolean
  createFailed: boolean
}

export default function ThreadView({
  slug,
  onCreateNew,
  creating,
  createFailed,
}: ThreadViewProps) {
  const sessionId = useCurrentSessionId()
  const sessions = useChatSessions()
  const loadingSessions = useLoadingSessions()

  if (sessionId) {
    return <ChatThread slug={slug} />
  }

  // A thread of the user's own is about to auto-open; loading while the
  // effect in useChatSidebarSession lands avoids an empty-state flash.
  const openingOwnThread = sessions.some((session) => session.mine)
  if (loadingSessions || creating || openingOwnThread) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader size="md" className="text-muted-foreground" />
      </div>
    )
  }

  return <EmptyChatState onCreate={onCreateNew} createFailed={createFailed} />
}
